import { lazier } from '@shared/components';

export const EditAdvancementModal = lazier(
  () => import('./EditAdvancementModal'),
  false,
);
export { default as EditAdvancementForm } from './EditAdvancementForm';
export { default as EditAdvancementButton } from './EditAdvancementButton';
